import { FormStore } from '@roc/feature-app-core';
import { createCurrencyField } from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const LowestPropertyAsIsValue = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Lowest Property As Is Value in the Portfolio",
        fieldName: 'minimumAsIsValue',
        testId: 'minimumAsIsValue',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});